import {makeKey,update} from '../../../../utils/reducerOperations';
export function fetchOrganizationStarted(state, payload) {
    return makeKey(
        'fetchOrganizationApi',
        update(state.fetchOrganizationApi, {isProcessing: true})
    );
}